import React from "react";

export function CypressTestPage() {
	return (
		<>
			<p>This is cypress test CypressTestPage</p>
		</>
	);
}
